import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'
// import require from 'require'

const Index = () => import('@/components/Index')
const Activity = () => import('@/components/Activity')
const List = () => import('@/components/List')

// import Index from '@/components/Index'
// import Activity from '@/components/Activity'
// import List from '@/components/List'

Vue.use(Router)
Vue.use(VueAxios, axios)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/Activity',
      name: 'Activity',
      component: Activity
    },
    {
      path: '/List',
      name: 'List',
      component: List
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js